import { render, staticRenderFns } from "./RegisterOpt.vue?vue&type=template&id=b9212430&scoped=true&"
import script from "./RegisterOpt.vue?vue&type=script&lang=js&"
export * from "./RegisterOpt.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOpt.vue?vue&type=style&index=0&id=b9212430&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9212430",
  null
  
)

export default component.exports